export default "__VITE_ASSET__CWNURhJn__"